import { ThemeOptions } from '@mui/material';

import button from './button';
import divider from './divider';
import iconbutton from './iconbutton';
import inputBase from './inputBase';
import inputLabel from './inputLabel';
import textfield from './textfield';

const components: ThemeOptions['components'] = {
  MuiButton: { ...button },
  MuiIconButton: { ...iconbutton },
  MuiTextField: { ...textfield },
  MuiInputLabel: { ...inputLabel },
  MuiInputBase: { ...inputBase },
  MuiDivider: { ...divider }
};

export default components;
